import React from "react";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Button,
  Grid,
  Box,
} from "@mui/material";
import { LocationOn } from "@mui/icons-material";
import imgurl from "./assests/images/imgurl";
import { useNavigate } from "react-router";

const Prescription = () => {
  const navigate = useNavigate();
  let lname = localStorage.getItem('lname')
  let fname = localStorage.getItem('fname')

  return (
    <>
      <div className="photo-container main-section-container assessmentReportSection prescriptionSection">
        <Grid
          container
          spacing={0}
          className="d-flex justify-content-start align-items-center"
        >
          <Grid item xs={1} className="">
            <div className="d-flex justify-content-start align-items-center">
              <span className="backButtonDiv">
                <ArrowBackOutlinedIcon className="arrowBackBtn"></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid>
          <Grid
            item
            xs={11}
            className="d-flex justify-content-center align-items-center"
          >
            <Typography variant="h6" className="title">
              Prescription
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          className="mt-20px"
        >
          <Grid item className="doctor-info">
            <Avatar
              src={imgurl.prescriptionImg}
              alt="Dr. Sarah Johnson"
              className="avatar"
            />
          </Grid>
          <Button variant="contained" className="pdf-button">
            Buy Now
          </Button>
        </Grid>

        <Grid container spacing={2} className="text-left">
          <Grid item xs={12}>
            <Box>
              <Typography variant="subtitle1" className="doctor-name">
                Dr. Sarah Johnson
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Hair Restoration Specialist
              </Typography>
              <Typography variant="body2" className="location">
                <LocationOn fontSize="small" /> Clinic Room 5, Alameda Principal
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Grid container spacing={2} className="text-left mt-20px">
          <Grid item xs={12} className="pt-0px">
            <Card className="commonCard">
              <CardContent className="pb-16px">
                <Box className="prescription-info">
                  <Typography variant="body2">
                    Prescription ID: 18476
                  </Typography>
                  <Typography variant="h6" className="patient-name">
                    Mr. {fname} {lname}
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Open: ID 124345
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        DOB: Feb 15, 1981
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card className="commonCard medication-card">
              <CardContent className="pb-16px">
                <Box className="prescription-info">
                  <Typography variant="subtitle1" className="section-title">
                    Prescribed Medication
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Alopexia Hair Restoration Medicine, Topical Solution, (60
                    ML),0.1%
                  </Typography>
                  <Typography
                    variant="body2"
                    className="pt-10px medication-time"
                  >
                    Frequency: Once daily
                  </Typography>
                  <Typography variant="body2" className="medication-time">
                    Duration: 60 days
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card className="commonCard medication-card">
              <CardContent className="pb-16px">
                <Box className="prescription-info">
                  <Typography variant="subtitle1" className="section-title">
                    Dosage Instructions
                  </Typography>
                  <Typography variant="body2">
                    Apply on dust and dry hair
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card className="commonCard medication-card">
              <CardContent className="pb-16px">
                <Box className="prescription-info">
                  {/* <Typography variant="subtitle1" className="section-title">
                    Pharmacy Details
                  </Typography>
                  <div>
                    <img src={imgurl.mapProfile} className="w-100"></img>
                  </div>

                  <Typography variant="body2" className="mt-20px">
                    Central Pharmacy,123 Healthcare Street, Ph No. (555)
                    123-4567
                  </Typography> */}
                  <div className="chatWindow">
                    <Grid
                      container
                      spacing={2}
                      className="d-flex justify-content-start align-items-center"
                    >
                      <Grid item xs={2}>
                        <img
                          src={imgurl.chat}
                          alt="Chat"
                          className="specialist"
                        />
                      </Grid>

                      <Grid item xs={10} className="chatgrid">
                        <div className="connecttexts">
                          <Typography className="firsttext">
                            Chat with us
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      className="d-flex justify-content-start align-items-center"
                    >
                      <Grid item xs={2}>
                        <img
                          src={imgurl.mailIcon}
                          alt="Phone"
                          className="specialist"
                          style={{ paddingLeft: "4px" }}
                        />
                      </Grid>

                      <Grid item xs={10} className="phonegrid">
                        <div className="connecttexts">
                          <Typography className="firsttext">
                            contact@alopexia.com
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={0}
          className="d-flex  align-items-center mt-20px"
        >
          <Grid item xs={3} className="d-flex justify-content-start">
            <p>Sign:</p>
          </Grid>
          <Grid item xs={9} className="d-flex justify-content-end">
            <div>
              <img
                src={imgurl.signature}
                alt="Signature"
                className="signature"
              />
              <div>
                <div className="border-top"></div>
                <p>Dr. Sarah Johnson</p>
              </div>
            </div>
          </Grid>
        </Grid>

        <div className="d-flex justify-content-center align-items-center flex-direction-column mt-20px">
          <Button
            variant="contained"
            className="commonButton"
            onClick={() => navigate("/productdetails")}
          >
            Buy Now
          </Button>
          <Button variant="outlined" className="outlinedButton w-100">
            Book Follow-up Appointment
          </Button>
        </div>
      </div>
    </>
  );
};

export default Prescription;
